import { render, staticRenderFns } from "./CodeAssignment.vue?vue&type=template&id=ee4e35dc"
import script from "./CodeAssignment.vue?vue&type=script&lang=js"
export * from "./CodeAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports